module.exports = __webpack_public_path__ + "img/R_SEC.a9248df9.svg";